import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/shared/serviceLayer/language.service';

@Component({
  standalone: false,
  selector: 'app-terms-and-condition-content',
  templateUrl: './termsandcondition-content.component.html',
})
export class TermsAndConditionContentComponent implements OnInit {
  currentLang: string;

  constructor(
    private titleService: Title,
    private meta: Meta,
    private languageService: LanguageService,
    private translateService: TranslateService,
  ) { }

  ngOnInit(): void {
    this.currentLang = this.languageService.getCurrentLang();

    this.translateService.onLangChange.subscribe(() => {
      this.currentLang = this.languageService.getCurrentLang();
    });

    this.titleService.setTitle("Terms and Conditions | Al Qaryah Auction");
    this.meta.updateTag({
      name: 'description',
      content: "Read the terms and conditions of participating in Al Qaryah Car Auction - UAE's top car auction platform."
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'terms and conditions, al qaryah auction, uae car auction, auction rules, sharjah auction, dubai cars auction, buy and sell cars'
    });
  }

  changeLanguage() {
    this.currentLang = this.currentLang === 'eng' ? 'ara' : 'eng';
    this.languageService.setLanguage(this.currentLang);
  }
}

